.contentLoader {
  height: 40px;
  width: 146px;
}
